import { render } from "./ReversalTable.vue?vue&type=template&id=b2d15ef4&scoped=true"
import script from "./ReversalTable.vue?vue&type=script&lang=js"
export * from "./ReversalTable.vue?vue&type=script&lang=js"

import "./ReversalTable.vue?vue&type=style&index=0&id=b2d15ef4&scoped=true&lang=css"

import exportComponent from "/home/aaicom7/repositories/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d15ef4"]])

export default __exports__